import { render, staticRenderFns } from "./chatFold.vue?vue&type=template&id=290a6c6b&scoped=true"
import script from "./chatFold.vue?vue&type=script&lang=js"
export * from "./chatFold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a6c6b",
  null
  
)

export default component.exports